const listerMetricsShown = () => {};

const listerMetricsHintClicked = () => {};

const analyticsTrackingEvents = () => {
  return {
    listerMetricsShown,
    listerMetricsHintClicked,
  };
};

export default analyticsTrackingEvents;
